// A labelled usage bar of the System pages (NextAdmin progress, `BudgetBar`); "—" when the box has not reported it.
import { BudgetBar } from '../../../components/ui/index.js';

export function UsageRow({ label, ratio, detail }: { label: string; ratio: number | null; detail?: string }) {
  if (ratio === null) {
    return (
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted">{label}</span>
        <span className="text-muted">—</span>
      </div>
    );
  }
  const pct = Math.max(0, Math.min(100, Math.round(ratio * 100)));
  return <BudgetBar value={pct} max={100} showPct label={detail ? `${label} · ${detail}` : label} />;
}
